import { render } from "./BinanceAnnouncements.vue?vue&type=template&id=00bdcf93&scoped=true"
import script from "./BinanceAnnouncements.vue?vue&type=script&lang=js"
export * from "./BinanceAnnouncements.vue?vue&type=script&lang=js"

import "./BinanceAnnouncements.vue?vue&type=style&index=0&id=00bdcf93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bdcf93"]])

export default __exports__